export enum StatusFilters {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  SHOW_ALL = 'SHOW_ALL',
}
